<div class="order-chart d-flex flex-column h-100">
  <div *ngIf="!account" class="h-100 d-flex align-items-center justify-content-center">
    <span class="text-center">{{msgOfflineNegotiation}}</span>
  </div>
  <app-grid-order class="h-100" *ngIf="account" [showCancelAllBtn]="true" [filters]="filters" [reducedColumns]="true" (gridReady)="onGridReady($event)">
  </app-grid-order>
</div>
